export const balancedCompute = 2;
export const lightCompute = 1;
export const heavyCompute = 4;
export const balancedBlock = 0;
export const lightBlock = 0;
export const heavyBlock= 0;